import React, { useState, useEffect } from "react";
import axios from "axios";

function Crousel() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBanners = async () => {
    try {
      const res = await axios.get(
        "http://api.compliancekare.com/api/Compliance/BannerList"
      );
      setBanners(res.data?.data || []);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h5>Loading banners...</h5>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0">
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        {/* Indicators */}
        <div className="carousel-indicators">
          {banners.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0}
            />
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          {banners.length > 0 ? (
            banners.map((banner, index) => (
              <div
                key={index}
                className={`carousel-item ${
                  index === 0 ? "active" : ""
                }`}
              >
                <img
                  src={`http://admin.compliancekare.com/BannerImage/${banner.bannerImage}`}
                  className="d-block w-100 carousel-img"
                  alt={`banner-${index}`}
                />
              </div>
            ))
          ) : (
            <div className="text-center p-5">
              <h5>No banners available</h5>
            </div>
          )}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
  );
}

export default Crousel;